<template>
<div class="report_custom page-content">
  <div class="content-header">
    <el-input
      class="search-input"
      v-model="custInfo"
      :placeholder="$t('Customer_Name')"
      clearable
    ></el-input>
    <vs-button
      class="search-btn"
      @click="searchHandle"
    >{{$t('search')}}</vs-button>
  </div>
  <div class="vs-table-outer">
    <vs-table :noDataText="$t('root.noData')" :data="listData">
      <template
        slot="thead">
        <vs-th>
          {{$t('User.reportCusId')}}
        </vs-th>
        <vs-th>
          {{$t('Customer_Name')}}
        </vs-th>
        <vs-th>
          {{$t('mobile_phone')}}
        </vs-th>
        <vs-th>
          {{$t('About.email')}}
        </vs-th>
        <vs-th>
          {{$t('Account_under_name')}}
        </vs-th>
         <vs-th>
           {{$t('Funds')}}
        </vs-th>
        <vs-th>
          {{$t('Certification_status')}}
        </vs-th>
        <vs-th>
          {{$t('Registration_time')}}
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data" >
          <vs-td>
            {{tr.id}}
          </vs-td>

          <vs-td>
            {{tr.userName}}
          </vs-td>

          <vs-td>
            {{tr.phone}}
          </vs-td>

          <vs-td>
            {{tr.email}}
          </vs-td>
          <vs-td>
          <span
            class="login-number"
            @click="belongHandle(tr)"
            :class="{
                            'theme-color': tr.loginNumber > 0,
                             pointer: tr.loginNumber > 0,
                            }"
          >{{tr.loginNumber}}</span>
          </vs-td>

          <vs-td>
          {{tr.totalBalance}}

          </vs-td>

          <vs-td>
            {{getStatus(tr)}}
          </vs-td>
          <vs-td>
            {{parseTime(tr.createTime)}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
  <div class="pagination-outer" v-if="total">
    <div class="paginnation-left">
      <size-change @sizeChange="sizeChange"></size-change>
      <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
    </div>
    <vs-pagination
      class="pagination-box"
      :max="max"
      :total="pageSize"
      v-model="page"
    ></vs-pagination>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/index';

// 表格字段需要重新调 todo
import initData from "@/mixins/initData";

export default {
  name: "index",
  data() {
    return {
      custInfo: '',
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo']),
  },
  created(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/crm/reception/partner/custList';
      this.params = {
        page: this.page -1,
        size: this.size,
        custId: this.userInfo.id,
        custType: 1,
      }
      if(this.custInfo){
        this.params.userInfo = this.custInfo;
      }
      return true;
    },
    belongHandle(row){
      if(!row.loginNumber){
        return;
      }
      this.$store.commit('setSubIbJumpToAccountListOfId', row.id);
      this.$router.push({
        name:'accountList'
      });
    },
    getStatus(row){
      switch (row.auditStatus) {
        case 0 || null:
          return this.$t('User.identifyStatus0');
        case 1:
          return this.$t('User.identifyStatus2');
        case 2:
          return this.$t('User.identifyStatus3');
        case 3:
          return this.$t('User.identifyStatus1');
        default:
          return this.$t('Authentication_failed');
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    }
  },
}
</script>

<style lang="scss" scoped>
.report_custom {
  background-color: #ffffff;

}
</style>
